import { render, staticRenderFns } from "./SwitchSelector.vue?vue&type=template&id=0cc558d9"
import script from "./SwitchSelector.vue?vue&type=script&lang=js"
export * from "./SwitchSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports